<body>
    <app-nav-menu #menu (stateChanged)="updateHeight($event)"></app-nav-menu>
    
    <div #tata class="container-fluid" [style.height]="PageHeight" [style.overflow-y]="Overflow" >
      <router-outlet></router-outlet>
    </div>
  </body>